<template>
    <div id="header-guest-container" :class="{'with-padding': !paddingSetted}">
        <!-- <div v-if="mobileDevices"></div> -->
        <div 
            class="header-navbar d-flex align-items-center w-100" 
            :class="{
                'position-fixed': !isMobile, 
                'dark-header': isDark,
                'no-shadow': isEcommercePlatform && !isDark
            }"
        >
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12" :class="{'px-0': showBar}">
                        <div v-if="showBar && !mobileDevices">
                            <SearchBar 
                                @hide="hide"/>
                        </div>
                        <div v-if="!showBar" class="cp-navbar d-flex align-items-center justify-content-between">
                            <div :class="{'mx-auto':isMobile}">
                                <router-link id="homepage-button" to="/">
                                    <Logo />
                                </router-link>
                            </div>
                            <div v-if="!isMobile">
                                <div v-if="!mobileDevices || isEcommercePlatform">
                                    <div class="action-bucket d-flex align-items-center" :class="landingPage ? 'justify-content-end':'justify-content-between'">
                                        <button id="search-icon-header" @click="showBar = true" v-if="!landingPage && !isEcommercePlatform">
                                            <SearchIcon />
                                        </button>
                                        <a
                                            v-if="!isEcommercePlatform"
                                            class="position-relative navbar-item has-badge"
                                            href="https://ecommerce.crossprom.com/"
                                            target="_blank"
                                            @click="toEcommerce">
                                            E-commerce
                                            <span></span>
                                        </a>
                                        <router-link
                                            v-if="!landingPage"
                                            class="navbar-item"
                                            to="/howitworks"
                                            @click.native="toHowItWorks">
                                            How it works
                                        </router-link>
                                        <a
                                            v-if="!isEcommercePlatform"
                                            class="navbar-item"
                                            href="https://help.crossprom.com/"
                                            target="_blank"
                                            @click="toCrosspromHelp">
                                            Help
                                        </a>
                                        <router-link
                                                v-if="!isEcommercePlatform"
                                                id="pricing-link"
                                                class="navbar-item"
                                                to="/pricing"
                                                @click.native="toPricing">
                                            Pricing
                                        </router-link>
                                        <div v-if="!isEcommercePlatform" style="border-left: 1px solid #D6DDE3; width: 1px; height: 24px" class="divider"></div>
                                        <div>
                                            <button :class="{'ecommerce-login-button': isEcommercePlatform && isDark}" id="login-button-header" class="login navbar-item" @click="showModal('login')">
                                                Login
                                            </button>
                                            <button id="signup-button-header" class="signup navbar-item" @click="showModal('sign-up')">
                                                Sign up
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <img 
                                    v-else
                                    src="/img/hamburger.png" 
                                    class="burger-bar" 
                                    @click="showSideBar = true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="mobileDevices && !isMobile" class="d-flex justify-content-end side-menu-wrapper" :class="{hidden: !showSideBar}" @click.self = "showSideBar = false">
                <SideMenu @hide="showSideBar = false"/>
            </div>
            <WelcomePlatform/>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SearchBar from './SearchBar'
import WelcomePlatform from '../popups/WelcomePlatform.vue'
import {clickOutside} from "@/directives/clickOutside";
import SideMenu from './SideMenu'

import {
    Logo,
    SearchIcon
} from './Icons'

export default {
    name: "HeaderGuest",
    components: {
        Logo,
        SearchIcon,
        SearchBar,
        WelcomePlatform,
        SideMenu
    },
    watch: {
        '$route.path': 'hide'
    },
    data() {
        return {
            showBar: false,
            show: false,
            mobileDevices: false,
            showSideBar: false,
            setLightHeader: false
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
        ...mapGetters([
            'isEcommercePlatform'
        ]),
        paddingSetted() {
            switch(this.$route.name) {
                case 'landingpage':
                    return true;
                case 'privacypolicy':
                    return true;
                case 'termsofuse':
                    return true;
                case 'pricing':
                    return true;
                default:
                    return false
            }
        },
        isDark() {
            return this.isEcommercePlatform && this.$route.name === 'landingpage' && !this.setLightHeader
        }
    },
    props: {
        isMobile: Boolean,
        landingPage: Boolean
    },
    watch: {
        '$route': 'getWindowWidth'
    },
    mounted: function() {
        this.changeHeaderBackgroundColor()
        this.hide()
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            this.getWindowWidth()
        })
    },
    destroyed: function() {
        this.changeHeaderBackgroundColor()
    },
    methods: {
        changeHeaderBackgroundColor() {
            if(!this.isDark) {
                return 
            }
            document.addEventListener('scroll', () => {
                if(window.scrollY > 0) {
                    this.setLightHeader = true
                    return
                }
                return this.setLightHeader = false
            })
        },
        toEcommerce(){
            this.$sendMixpanelEvent('Ecommerce Link Clicked', {
                'Link Location': 'Navbar',
                'LoggedIn': false
            });

            this.$ga.event('Ecommerce Clicked', 'Click', `
                Link Location: Navbar,
                LoggedIn: false
            `)
        },
        getWindowWidth(event) {
            this.mobileDevices = document.documentElement.clientWidth < 768
        },
        hide: function() {
            this.showBar = false
        },
        toHowItWorks(){
            this.$ga.event('Navbar', 'How It Works Click')
            this.$sendMixpanelEvent('Navbar How It Works Clicked');
        },
        toPricing(){
            this.$sendMixpanelEvent('Pricing Page Opened', {
                'Opened From': 'Navbar Pricing Link',
                'Logged In': false
            });

            this.$ga.event('Pricing', 'Pricing Page Opened',`
                OpenedFrom:Navbar Pricing Link,
                LoggedIn:false
            `);
        },
        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: false,
                Location: Navbar
            `)
            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': false,
                'Link Location': 'Navbar'
            });
        },
        showModal(modalName, actionName){
            this.$store.dispatch('clearErrors');
            if(this.user && this.user.uid) {
                this.$router.push('/browse')
                return
            }
            this.$store.commit('TOGGLE_MODAL', [modalName, {
                openedFrom: 'Navbar',
                chosenPlanOnSignup: modalName === 'sign-up' ? {name: 'basic'} : null
            }]);
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },
    directives: {
        clickOutside
    }
}
</script>

<style scoped lang="scss">
// div#header-guest-container {
//     width: 100%;
//     z-index: 9999;
//     position: fixed;
//     top: 0;
//     transition: top 0.3s;
// }
.dark-header {
    height: 64px;
    background: #00002D;
    box-shadow: inset 0px -1px 0px rgba(114, 124, 245, 0.3);
    transition: all 0.2s ease;
    button.signup#signup-button-header {
        background: #727CF5 !important;
    }
    button.login {
        color: #FFFFFF !important;
        &:hover {
            color: #FFFFFF !important;
        }
    }
}
.header-navbar {
    transition: all 0.2s ease;
    z-index: 1000;
    &.no-shadow {
        box-shadow: inset 0px -1px 0px #E2E8F0;
    }
}

.burger-bar {
    cursor: pointer;
}
#header-guest-container.with-padding {
    padding-bottom: 60px;
}
div.action-bucket {
    button {
        &.login {
            color: #8DA0A9;
            &:hover {
                color: #000000;
            }
        }
        &.ecommerce-login-button {
            &:hover {
                color: #FFFFFF !important;
            }
        }
        &.signup {
            width: 98px;
            height: 32px;
            background: #0ACF97 !important;
            border-radius: 5px;
            color: #FFFFFF;
            transition: all 0.1s linear;
    
            &:hover {
                background: #0ACF97 !important;
                box-shadow: 0px 4px 10px rgba(10, 207, 151, 0.39);
                border-radius: 5px;
                border: 0 !important;
                outline: 0 !important;
                color: #FFFFFF !important;
            }
        }
    }

    .navbar-item {
        margin-right: 12px;
        font-size: 14px;
        line-height: 20px;
        font-family: 'Eina SemiBold';
        color: #8DA0A9;
        transition: all 0.2s ease;
        padding: 0 8px;
        margin: 0 12px;
        &:hover {
            color: #727CF5 !important;
        }
        &.has-badge {
            display: flex;
            span {
                display: flex;
                position: relative;
                background: #727CF5;
                border-radius: 2px;
                color: #fff;
                display: inline-block;
                padding: 0px 2px;
                width: 23px;
                height: 11px;
                margin-left: 2px;

                &::after {
                    content: 'new';
                    position: absolute;
                    display: inline-block;
                    font-size: 9px;
                    line-height: 9px;
                }
            }
        }
        
    }

}

.side-menu-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100vh;
    right: 0;
    transform: translate(0);
    transition: .5s;

    &.hidden {
        transform: translate(100%)
    }
}

</style>